import { useState, useMemo } from 'react';
import type { PromptTemplate } from '../../../store/promptManager';

interface TemplateSelectorProps {
  templates: PromptTemplate[];
  selectedTemplateId: string;
  onSelect: (id: string) => void;
}

const TemplateSelector = ({ templates, selectedTemplateId, onSelect }: TemplateSelectorProps) => {
  // 用于搜索过滤
  const [searchTerm, setSearchTerm] = useState('');
  
  // 过滤模板
  const filteredTemplates = useMemo(() => {
    if (!searchTerm) return templates;
    
    const term = searchTerm.toLowerCase();
    return templates.filter(
      template => 
        template.name.toLowerCase().includes(term) || 
        template.description.toLowerCase().includes(term)
    );
  }, [templates, searchTerm]);
  
  return (
    <div className="template-selector">
      <div className="template-search">
        <input
          type="text"
          placeholder="搜索模板..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      
      <div className="template-grid">
        {filteredTemplates.map(template => (
          <div
            key={template.id}
            className={`template-card ${template.id === selectedTemplateId ? 'selected' : ''}`}
            onClick={() => onSelect(template.id)}
          >
            <h5>{template.name}</h5>
            <p>{template.description}</p>
          </div>
        ))}
        
        {filteredTemplates.length === 0 && (
          <div className="no-results">没有找到匹配的模板</div>
        )}
      </div>
    </div>
  );
};

export default TemplateSelector; 